import { Container, Card, Typography } from '@mui/material';
import Page from '../../components/Page';
import FuneralFormSection from '../../sections/@dashboard/funerals/FuneralFormSection';

export default function FuneralCreate() {
  return (
    <Page title="New Funeral Form">
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>New Funeral Form</Typography>
        <Card sx={{ p: 3 }}>
          <FuneralFormSection funeralForm={null} />
        </Card>
      </Container>
    </Page>
  );
}
